export const DOCUMENT_METADATA_TYPE = {
    CombinePDFError: 'CombinePDFError',
};
export const DOCUMENT_TYPES_KEY = 'DOCUMENT_TYPES';
export const UPLOAD_TYPES = {
    SINGLE: 'SINGLE',
    BULK: 'BULK'
};
